import freeTextMapping from "../components/freeTextMapping";
import heroMapping from "../components/heroMapping";
import mediaTextMapping from "../components/mediaTextMapping";
import socialMediaMapping from '../components/socialMediaMapping';
import recipesComponentMapping from "../components/recipesComponentMapping";

const promotionsPageMapping = (data) => {
  const mappedData = {};
  let components = data.data.relationships.field_components.data;

  mappedData.hero = heroMapping(components.find(component => {
    return component.type === "paragraph--hero_carousel_component"
  }));

  mappedData.content = components.map((component) => {
    // eslint-disable-next-line default-case
    switch (component.type) {
      case "paragraph--free_text_component":
        return { freeText: freeTextMapping(component) };
      case "paragraph--media_text_component":
        return { mediaText: mediaTextMapping(component) };
      case "paragraph--social_media_component":
        return { social: socialMediaMapping(component)};
    }
  }).filter((element) => {
    return element !== undefined;
  });

  mappedData.promotionsComponent = recipesComponentMapping(components.find(component => {
    return component.type === "paragraph--recipes_component"
  }));

  return mappedData;
};

export default promotionsPageMapping;
